import axios from "axios";
import store from "@/store";
// import config from "@/config";

const axiosConfig = {
  // baseURL: config.API_URL,
  timeout: 25000,
};

const http = axios.create(axiosConfig);
// http.defaults.headers.common["Authorization"]='AUTH_TOKEN'
// http.defaults.headers.common["Authorization"] =
//   "";
http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

// Add a request interceptor
http.interceptors.request.use(
  function (config) {
    store.commit("loading/UPDATE_LOADING_STATE", true);
    const userInfoStr = localStorage.getItem("user");
    let userInfo = null;
    if (userInfoStr) userInfo = JSON.parse(userInfoStr);
    if (userInfoStr && userInfo && userInfo.accessToken) {
      config.headers.Authorization = userInfo.accessToken
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    store.commit("loading/UPDATE_LOADING_STATE", true);
    return Promise.reject(error);
  }
);

// Add a response interceptor
http.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    store.commit("loading/UPDATE_LOADING_STATE", false);
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    store.commit("loading/UPDATE_LOADING_STATE", false);
    return Promise.reject(error);
  }
);

function handleParams(url, rawData, rawMethod, useFunc) {
  const method = rawMethod.toUpperCase();
  let data = {};
  if (useFunc === "params") {
    switch (method) {
      case "GET":
        data = { params: rawData };
        break;
      case "POST":
        data = { params: rawData };
        break;
      case "PUT":
      case "PATCH":
      case "DELETE":
        data = { params: rawData };
        break;
      default:
        data = { data: rawData };
        break;
    }
  } else if (useFunc === "body") {
    switch (method) {
      case "GET":
        data = { data: rawData };
        break;
      case "POST":
        data = { data: rawData };
        break;
      case "PUT":
      case "PATCH":
      case "DELETE":
        data = { data: rawData };
        break;
      default:
        data = { data: rawData };
        break;
    }
  }
  return {
    url,
    method,
    data,
  };
}

export const fetchApi = (url, rawData = {}, method = "get", useFunc = "params") => {
  const options = handleParams(url, rawData, method, useFunc);
  return new Promise((resolve, reject) => {
    http({
      withCredentials: true,
      url: options.url,
      method: options.method,
      ...options.data,
    }).then((resp) => {
      const res = resp.data;
      resolve(res);
    }),
      (error) => {
        reject(error);
      };
  });
};

export default http;
